import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_ORGANIZATION_PATH,
  GetOrganizationsErrorDto,
  GetOrganizationsRequestPathVariables,
  GetOrganizationsRequestQueryParams,
  GetOrganizationsSuccessDto,
} from '@/api/rest/resources/types/organization';

type SuccessDto = GetOrganizationsSuccessDto;
type ErrorDto = GetOrganizationsErrorDto;
type PathVars = GetOrganizationsRequestPathVariables;
type QueryParams = GetOrganizationsRequestQueryParams;

export const useOrganization = (queryParams?: QueryParams) => {
  const queryFn = async () => {
    return getRequest<SuccessDto, PathVars, QueryParams>(GET_ORGANIZATION_PATH, undefined, queryParams);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['organization', queryParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
